import type { SVGProps } from 'react';

export function NewIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M19 9l-2.24 4.76L12 16l-4.76-2.24L5 9l2.24-4.76L12 2l4.76 2.24L19 9zm-7 10l1.63-3.26L17 14.11l-3.26-1.63L12 9l-1.63 3.48L7 14.11l3.26 1.63L12 19z" />
    </svg>
  );
}
